<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onMounted } from 'vue';

export default {
  data() {
    return {
      //必须配置项，从接口获取
      appId: "",
      timestamp: "",
      noncstr: "",
      signatureInfo: "",
      // 自配项
      imgurl: "",//分享图片（如分享出来链接上显示的小图标）
      url: "",//分享地址（如分享出来一个链接，点链接要跳的页面地址）
    }
  },
  created() {
    this.handleShare()
  },
  watch: {
    '$route.query': {
      handler() {
        this.shareFriend()
      }
    }
  },
  methods: {
    handleShare() {
      this.url = window.location.href;
      //指的是要做分享的页面的url送过去，请求成功才能拿到
      this.$appFetch({
        url: 'https://api.artroncloud.com/wx/js-api-sign',//请求微信分享的接口地址
        method: 'post',
        headers: {
          Client: 'yc_web',
        },
        data: {
          web_url: this.url
        },
      }, res => {
        if (res.success) {
          //这些配置参数必填项，后面去调微信的pai是需要传的。
          this.appId = res.data.app_id;
          this.timestamp = res.data.timestamp;
          this.noncstr = res.data.noncestr;
          this.signatureInfo = res.data.sign;
          this.shareFriend()
        }
      }, err => { console.log(err) })
    },

    shareFriend() {//当点击分享好友按钮时
      //怎么取图片的地址取决于你放图片的路径，你也可以用线上图片，也可以放在你们的服务器上。
      if (window.location.pathname == '/m_onlineChose') {
        this.imgurl = 'https://hlmtj.artroncloud.com/static/images/share2.jpg';
      } else {
        this.imgurl = 'https://hlmtj.artroncloud.com/static/images/share1.jpg';
      }
      this.title = "《红楼梦》绘本艺术图集专题";
      this.desc = "";
      this.goshare()
    },

    goshare() {
      let that = this;
      //开始注入配置项
      let a = this.$wx.config({
        debug: false,//是否打开debug调试模式。
        appId: this.appId,	//必填，公众号唯一标识
        timestamp: this.timestamp,	//必填，生成签名的时间戳
        nonceStr: this.noncstr,	//必填，生成签名的随机串
        signature: this.signatureInfo,	//必填，生成的签名
        jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']	//必填，允许分享好友，分享朋友圈
      })
      this.$wx.error((res) => {//配置成功
        for (var msg in res) {
          let obj = {
            showAlert: true,
            errTitle: "错误提示",
            errMsg: JSON.stringify(res[msg]),
            errCode: ""
          }
        }
      })
      let link = window.location.href;
      this.$wx.ready(() => {//点击要去分享
        this.$wx.updateAppMessageShareData({//配置去分享好友的选项
          title: this.title,
          link,
          desc: this.desc,
          imgUrl: this.imgurl,
          success: function (res) {
            console.log("分享好友成功")
          },
          cancel: function (res) {
            console.log("分享失败")
          }
        });
        this.$wx.updateTimelineShareData({//配置去分享朋友圈的选项
          title: this.title,//分享标题
          link, //分享链接
          imgUrl: this.imgurl, //分享图标
          success: function (res) {//分享成功 
            console.log("已分享朋友圈成功")
            //如分享成功后想做一些其他的业务处理，可以在这里做
          },
          cancel: function () {
            //that.alert="失败弹框话术等等(注意 这里拿不到this实例的)"
            console.log("已分享失败")
          }
        })
      })
    }
  }
}
</script>
